import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode; }
interface State { hasError: boolean; }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(): State { return { hasError: true }; }
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void { console.error("[ErrorBoundary]", error, errorInfo); }
  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "2rem", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
          <h1 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: "0.5rem" }}>Something went wrong</h1>
          <p style={{ color: "#64748b", marginBottom: "1.5rem" }}>An unexpected error occurred. Please try refreshing the page.</p>
          <button type="button" onClick={() => window.location.reload()} style={{ padding: "0.625rem 1.5rem", borderRadius: "0.5rem", backgroundColor: "#0d9488", color: "#fff", border: "none", cursor: "pointer", fontSize: "0.875rem", fontWeight: 500 }}>Refresh Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}
